<!--
 * @Author: hongye
 * @Description: 
-->
<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span class="main-r_top_nav" :class="mainStatus === 'online' && 'active'" @click.stop="handleClick('online')">{{ $lang('在线文档') }}</span>
      <!-- <span class="main-r_top_nav" :class="mainStatus === 'apiTest' && 'active'" @click.stop="handleClick('apiTest')">测试工具</span> -->
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    <!-- 测试工具 END -->
  </div>
</template>

<script>
  import onlineDoc from "../components/onlineDoc";

  import apiTestDoc from "../components/apiTestDoc";

  import { OPEN_API_TEST, OPEN_API_PRO } from "@/constants/index";
  const apiUrlTest = "billCode/getBatchBillCode";
  export default {
    name: "getwaybill",
    components: { onlineDoc, apiTestDoc },
    data() {
      return {
        mainStatus: "online",
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

        onlineData: {
          //接口描述
          apiDesc:
            "与网点进行签约的客户，通过网点编码与业务员编码可进行提前获取电子面单库存",
          //接口地址
          testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
          proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
          //参数描述  START
          postDataList: [
            //   请求头参数
            {
              title: "Headers",
              value: [
                {
                  name: "apiAccount",
                  type: "Number",
                  require: "Y",
                  normal: "",
                  describe: "接入方在平台的api账户标识",
                },
                {
                  name: "digest",
                  type: "String",
                  require: "Y",
                  normal: "",
                  describe: "签名字符串",
                },
                {
                  name: "timestamp",
                  type: "Number",
                  require: "Y",
                  normal: "",
                  describe: "时间戳，毫秒",
                },
              ],
            },
            {
              title: "请求参数",
              value: [
                {
                  name: "bizContent",
                  type: "String",
                  require: "Y",
                  normal: "业务参数",
                  describe: "业务参数模块内json格式的string类型",
                },
              ],
            },
            {
              title: "业务参数",
              value: [
                {
                  name: "code",
                  type: "String(30)",
                  require: "Y",
                  normal: "",
                  describe: "业务员编码或客户编码（区分大小写，联系出货网点提供）",
                },
                {
                  name: "codeType",
                  type: "String(30)",
                  require: "Y",
                  normal: "",
                  describe:
                    `01：客户编码（获取客户号段时，需采用客户账号密码加密）
                    02：业务员编码（获取业务员号段时，需采用网点编码加密）`,
                },
                {
                  name: "digest",
                  type: "String(50)",
                  require: "Y",
                  normal: "",
                  describe:
                    `客户编码
                    <p>签名，Base64(Md5(客户编号+密文+privateKey))，其中密文：MD5(明文密码+jadada236t2) 后大写</p>
                    <p>业务员编码</p>
                    <p>签名，Base64(Md5(业务员编码+密文+privateKey))，其中密文：(网点编码+jadada236t2) 大写</p>`,
                },{
                  name: "num",
                  type: "Integer",
                  require: "Y",
                  normal: "",
                  describe: "请输入获取数量，最多一次可获取10个",
                }
              ],
            },
          ],
          //参数描述  END
          //报文描述 start
          responseDataList: [
            //   响应参数
            {
              title: "响应参数",
              value: [
                {
                  name: "code",
                  type: "String",
                  require: "Y",
                  normal: "",
                  describe: "返回码，见附录",
                },
                {
                  name: "msg",
                  type: "String",
                  require: "Y",
                  normal: "",
                  describe: "描述",
                },
                {
                  name: "data",
                  type: "Object",
                  require: "",
                  normal: "",
                  describe: "业务数据",
                },
              ],
            },
            // data类型说明
            {
              title: "data类型说明",
              value: [
                {
                  name: "billCodes",
                  type: "List<String>",
                  require: "Y",
                  normal: "",
                  describe: "通用电子面单运单号",
                },
              ],
            },
          ],
          //请求示例
          requestCode: `Header：
      apiAccount=1565238848921
      digest=U40e5sumorgd3YgZzU61Mw==
      timestamp=1001

  Body：
      bizContent=  {
    "code":"J0086000736",
    "codeType":"01",
    "num":"10",
    "digest":"12oAFDImkoIn94lMJGzjQA==1"
  }`,
          //返回示例
          responseCode: JSON.parse(
            `{
  	"code": "1",
    "msg": "success",
    "data":{
          "billCodes": [
            "UT0000346840348",
            "UT0000347056956",
            "UT0000347023053",
            "UT0000346997194",
            "UT0000346802241",
            "UT0000347144624",
            "UT0000347226577",
            "UT0000346763286",
            "UT0000347161687",
            "UT0000347031325"
        ]
    }
  }`
          ),

          //错误代码提示
          errcodeJson: [{code:'1450033310',msg:"电子面单库存不足"},{code:'145003336',msg:"编码不能为空"},{code:'145003337',msg:"编码类型不能为空"},{code:'145003338',msg:"获取数量不能为空"},{code:'145003339',msg:"请数据正确数量"}
          ],
        },

        apiTestData: {
          _headerData: {
            apiAccount: "1001",
            digest: "U40e5sumorgd3YgZzU61Mw==",
            timestamp: "1565238848921",
          },
          data: {
            bizContent: `{"code":"J0086000736","codeType":"01","num":"10","digest":"12oAFDImkoIn94lMJGzjQA==1"}`,
          },
          //必须要验证的参数
          requestData: ["apiAccount", "digest", "timestamp", "bizContent"],
          textareaData: {
            bizContent: true,
          },
          //促发接口
          apiUrl: `/mock/${apiUrlTest}`,
          //返回
          ResponseJson: "",
          //当前请求URL
          apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,
          //错误代码提示
          errcodeJson: [
            {code:'1450033310',msg:"电子面单库存不足"},{code:'145003336',msg:"编码不能为空"},{code:'145003337',msg:"编码类型不能为空"},{code:'145003338',msg:"获取数量不能为空"},{code:'145003339',msg:"请数据正确数量"}
          ],
        },
      };
    },
    methods: {
      handleClick(status) {
        this.mainStatus = status;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../css/apiTest.scss";
</style>
